import httpClient from "../../api/httpClient";
import Grupo from "../classes/GrupoBroadcast";

interface HttpCalls {
    method: string;
    rota: string;
}

const calls: HttpCalls[] = [
    { method: "GET", rota: "Broadcast/GrupoBroadcast/All" },
    { method: "GET", rota: "Broadcast/GrupoBroadcast/AllActive" },
    { method: "POST", rota: "Broadcast/GrupoBroadcast/Adicionar" },
    { method: "PUT", rota: "Broadcast/GrupoBroadcast/Atualizar" },
    { method: "DELETE", rota: "Broadcast/GrupoBroadcast/Apagar" }
];

const cacheKey: string = "GrupoCache";
const cacheKeySelC: string = "GrupoSelecionado";

const apiServico: String = "PORTAL"

class GrupoDataset extends httpClient {

    constructor() {
        super(String(apiServico));
    }

    async ListarAtivos(): Promise<Grupo[]> {
        return await super.Get(calls[0].rota)
            .then((response) => {
                return JSON.parse(JSON.stringify(response.data));
            })
            .catch((erro) => {
                console.error(erro)
            });
    }

    Adicionar(value: Grupo) {
        let ok: boolean = false;
        let error: any = undefined;
        super.post(calls[2].rota, value).then((result) => {
            ok = JSON.parse(result);
        }).catch((erro) => {
            ok = false;
            error = erro;
        });
        if (error !== undefined && ok === false)
            throw error;
    }

    Atualizar(value: Grupo) {
        let ok: boolean = false;
        let error: any = undefined;
        super.put(calls[3].rota, value).then((result) => {
            ok = JSON.parse(result);
        }).catch((erro) => {
            ok = false;
            error = erro;
        });
        if (error !== undefined && ok === false)
            throw error;
    }

    Apagar(value: Grupo) {
        let ok: boolean = false;
        let error: any = undefined;
        super.delete(calls[4].rota, value).then((result) => {
            ok = JSON.parse(result);
        }).catch((erro) => {
            ok = false;
            error = erro;
        });
        if (error !== undefined && ok === false)
            throw error;
    }



    getKeyCach(): string {
        return cacheKey;
    }

    getKeyCachClass(): string {
        return cacheKeySelC;
    }

    ListarFromCache(): Grupo[] {
        let result: Grupo[] = JSON.parse(cacheKey);
        return result;
    }

    AdicionarListaAoCache(value: Grupo[]) {
        localStorage.setItem(cacheKey, JSON.stringify(value));
    }

    LimparListaDoCache() {
        localStorage.removeItem(cacheKey);
    }

    AdicionarObjetoAoCache(value: Grupo) {
        localStorage.setItem(cacheKeySelC, JSON.stringify(value));
    }

    LimparObjetoDoCache() {
        localStorage.removeItem(cacheKeySelC);
    }

}
export default GrupoDataset;